// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*{font-display:swap}@media screen and (max-width: 1200px){a.logo-left{text-align:center;display:flex;justify-content:center}a.logo-left img{width:90%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
